import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Tooltip, TrevorIcon } from '@trevor/ui-components';
import { DASHBOARD_ADD_SAVED_QUERY_BUTTON } from '@/constants/test-ids';
import { ACTION_CLICK_ADD_SAVED_QUERY } from '@/components/HighlightFeature';
import { showOnboarding } from '@/util/helpers/onboarding-helpers';
import { getUserActions } from '@/store-selectors';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  selectIsWidgetConfigurationSidebarOpen,
  toggleWidgetConfigurationSidebar,
} from '@/features/dashboard/dashboardSlice';
import {
  chartConfigurationApi,
  QUERY_AVAILABLE_CHARTS,
} from '@/features/chart-configuration/apiSlice';
import { BuildDashboardOnboarding } from '@/features/dashboard/components/BuildDashboardOnboarding';
import { AddMoreChartsOnboarding } from '@/features/dashboard/components/AddMoreChartsOnboarding';

const addWidgetButtonTootipId = 'add-widget-button-tooltip-id';

export const AddWidgetButton = () => {
  const dispatch = useAppDispatch();
  const isWidgetConfigurationSidebarOpen = useAppSelector(
    selectIsWidgetConfigurationSidebarOpen,
  );
  const userActions = useSelector(getUserActions);
  const appliedFilters = useSelector((s: any) => s.dashboards.appliedFilters);
  const chartWidgets = useSelector((s: any) => s.dashboards.chartWidgets);
  const textWidgets = useSelector((s: any) => s.dashboards.textWidgets);

  const hasAppliedFilters = appliedFilters.length > 0;
  const hasWidgets = chartWidgets.length > 0;
  const hasTextWidgets = textWidgets.length > 0;

  const isBuildDashboardsOnboardingShown =
    !hasWidgets && !hasTextWidgets && !isWidgetConfigurationSidebarOpen;
  const isAddMoreChartsOnboardingShown =
    !isBuildDashboardsOnboardingShown &&
    showOnboarding(userActions, ACTION_CLICK_ADD_SAVED_QUERY);
  const isDisabled = hasAppliedFilters || isWidgetConfigurationSidebarOpen;

  const handleAddWidgetClick = () => {
    dispatch(
      chartConfigurationApi.util.invalidateTags([QUERY_AVAILABLE_CHARTS]),
    );
    dispatch(toggleWidgetConfigurationSidebar());
    dispatch({
      type: 'WIDGET_ADDED',
      payload: {
        display: 'preview',
      },
    });
  };

  return (
    <Button
      id="dashboard-add-insight"
      data-testid={DASHBOARD_ADD_SAVED_QUERY_BUTTON}
      icon={<TrevorIcon name="bar-chart" />}
      disabled={isDisabled}
      onClick={isDisabled ? undefined : handleAddWidgetClick}
      data-tooltip-id={addWidgetButtonTootipId}
    >
      Add chart
      {!isDisabled && (
        <>
          {isBuildDashboardsOnboardingShown && <BuildDashboardOnboarding />}
          {isAddMoreChartsOnboardingShown && <AddMoreChartsOnboarding />}
        </>
      )}
      <Tooltip id={addWidgetButtonTootipId}>
        {hasAppliedFilters
          ? 'Please clear your dashboard filters before adding more widgets'
          : 'Add to dashboard'}
      </Tooltip>
    </Button>
  );
};
